import type { Infer } from 'superstruct';
import { boolean, object, optional } from 'superstruct';

import { makeRecord } from '@adflow/shared/util-js';

import { permissionSystem } from './permissions';

const PermissionValuesDto = object(
	makeRecord(permissionSystem.actionTypes, () => optional(boolean()))
);

export const PermissionsDto = object(
	makeRecord(permissionSystem.permissionTypes, () =>
		optional(PermissionValuesDto)
	)
);

export type PermissionsDto = Infer<typeof PermissionsDto>;
